import { render } from 'preact';
import { App } from './App.jsx';
import './style.css';

render(<App />, document.getElementById('app'));
